import React, { forwardRef, useImperativeHandle } from "react";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import AlertTitle from '@mui/material/AlertTitle';


function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
}

function TransitionUp(props) {
return <Slide {...props} direction="up" />;
}

function TransitionRight(props) {
return <Slide {...props} direction="right" />;
}

function TransitionDown(props) {
return <Slide {...props} direction="down" />;
}


const Message= forwardRef((props, ref) => {
            const [open, setOpen] = React.useState(false);
            const [message, setMsg]  = React.useState('');
            const [NotDangerouslySetInnerHTML, setNotDangerouslySetInnerHTML]  = React.useState(false);
            const [msgTitle, setTitle] = React.useState('Los siguientes campos son requeridos');
            const [msgType, setType] = React.useState('error');
            const [transition, setTransition] = React.useState(undefined);

            useImperativeHandle(ref, () => ({
                show (msg,title,type, notDangerouslySetInnerHTML)  {
                    setMsg(msg);                    
                    setNotDangerouslySetInnerHTML(notDangerouslySetInnerHTML);
                    setOpen(true);
                    if (title==undefined){
                        title="";
                    }
                    setTitle(title);
                    if (type==undefined){
                        type="error";
                    }
                    setType(type);   
                    setTransition(() => TransitionDown);                
                }
            }));

            const close = (event, reason) => {
                if (reason === 'clickaway') {
                return;
                }
                setOpen(false);
            };
            return(
                <div>
                    <Snackbar 
                    style={{ height: "100%" }}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "center"
                    }}
                    TransitionComponent={transition}
                    open={open} autoHideDuration={2000} onClose={close}>
                            <Alert  onClose={close} severity={msgType}>
                            <AlertTitle>{msgTitle}</AlertTitle>
                                {!NotDangerouslySetInnerHTML &&
                                        <div                                        
                                            dangerouslySetInnerHTML={{
                                                __html: message
                                            }}>
                                       </div>
                                }
                                 {NotDangerouslySetInnerHTML &&
                                        <div>
                                            {message}
                                       </div>
                                }
                            </Alert>
                    </Snackbar>
                </div>
            )
});

export default Message;